import React, { useState, useRef, useContext, useEffect, useMemo } from 'react';
import { store } from 'components/Store';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import InfluenceCrmSideBar from 'components/Dashboard/Influence/InfluenceCrmSideBar/InfluenceCrmSideBar';
import { useLocation, useParams } from 'react-router';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import LocalStorage from 'utils/LocalStorage';
import { MobileMenu } from 'components/Dashboard/components/SectionTitle';

const InfluenceSectionTitle = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { listDomainsVerified, crmContactsQtty, team } = state;

  const { newAgencyPlan } = useTopicOrClientWord();

  const isMobile = useIsMobile();
  const [showBox, setShowBox] = useState(false);

  const actionsElement = useRef(null);
  const titleElement = useRef(null);

  const location = useLocation();
  const params = useParams();
  const { groupId } = params;

  const hideActions = () => {
    setShowBox(false);
  };

  const needsDomainVerification =
    (!listDomainsVerified.verifiedDomains.length ||
      (!listDomainsVerified.allDomains.length && !listDomainsVerified.verifiedEmailAddresses.length) ||
      !listDomainsVerified.verifiedEmailAddresses.length) &&
    !listDomainsVerified.domainsProccessing;

  const firstTimeContactsAdded = useMemo(() => {
    return JSON.parse(LocalStorage.getItem('firstTimeContactsAdded'));
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      if (firstTimeContactsAdded?.animationShown === false) {
        LocalStorage.setItem(
          'firstTimeContactsAdded',
          JSON.stringify({ firstTimeContactsAdded: true, animationShown: true })
        );
      }
    };
  }, [location.pathname]);

  const influenceRoute = location.pathname.split('/')?.[1];
  const innerInfluenceRoute = location.pathname.split('/')?.[2];
  // Suppressed only for a specific email's own detail view (EmailPerformanceNav's dropdown/actions
  // bar serves as the title there instead) - the bare /email-performance overview still wants a title.
  const emailComponentPage =
    (innerInfluenceRoute === 'emails' && location.pathname.split('/')?.[3]) ||
    (innerInfluenceRoute === 'email-performance' && location.pathname.split('/')?.[3]);

  const influenceSectionMapping = {
    'stakeholder-mapping': 'Stakeholder mapping',
    directory: 'Directory',
    'lobbying-material': newAgencyPlan ? `Content for ${team?.teamName}` : 'Lobbying material',
    emails: ((needsDomainVerification && isMobile) || !needsDomainVerification) && 'Email campaigns',
    inbox: 'Inbox',
    'engagement-statistics': 'Engagement statistics',
    'email-performance': 'Email performance',
    policymakers: 'Policymakers',
    'ai-assistant': 'AI assistant',
    'my-groups': newAgencyPlan ? `Groups for ${team?.teamName}` : 'My groups',
    interactions: 'Interactions',
    'engagement-stats': 'Engagement stats',
  };

  const showItemDropdown = isMobile;
  return (
    <>
      <div>
        {((crmContactsQtty && innerInfluenceRoute === 'contacts') || innerInfluenceRoute !== 'contacts') && (
          <>
            <div className='section-title-left-side' ref={actionsElement}>
              <div className='position-relative'>
                {!emailComponentPage && (
                  <h3
                    ref={titleElement}
                    className='my-lg-0 main-title mb-0 nowrap-item mr-3'
                    onClick={() => {
                      if (showItemDropdown) {
                        setShowBox(!showBox);
                      }
                    }}
                  >
                    <span
                      className={`font-weight-bold ${
                        showItemDropdown ? 'dropdown-item-element pointer dropdown-item-element-main-title' : ''
                      } ${showBox ? 'open' : ''}`}
                    >
                      {!!groupId ? <></> : <>{influenceSectionMapping[innerInfluenceRoute ?? influenceRoute]}</>}
                    </span>
                  </h3>
                )}
                {showBox && (
                  <>
                    <MobileMenu
                      showBoxState={{ showBox, setShowBox }}
                      titleElement={titleElement}
                      additionalClass='influence-section-picker'
                    >
                      <InfluenceCrmSideBar closeMenu={hideActions} mobile />
                    </MobileMenu>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InfluenceSectionTitle;
